import { siteDashboardPath, siteEditPath } from '@/common/app/path'
import { Site } from '@/common/model/site'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import Button from '@/components/view/atoms/button/Button'
import TextButton from '@/components/view/atoms/button/TextButton'
import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import ClickableTableRow from '@/components/view/atoms/table/ClickableTableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text from '@/components/view/atoms/text/Text'
import ItemAlign from '@/components/view/layouts/item/ItemAlign'

interface Props {
  site: Site
  isScrolled: boolean
}

const SiteListRow = ({ site, isScrolled }: Props) => {
  return (
    <ClickableTableRow href={siteEditPath(site.id)}>
      <TableRowItem scrollShadow={isScrolled} width={40}>
        <Text size={14}>{site.id}</Text>
      </TableRowItem>
      <TableRowItem>
        <TextButton link={siteEditPath(site.id)} bold>
          {site.name}
        </TextButton>
      </TableRowItem>
      <TableRowItem width={160}>
        <Button link={siteDashboardPath(site.id)} size='large'>
          <ItemAlign gapX={4} direction='horizon' nowrap align='end'>
            <Icon type={IconType.DOOR} color={IconColor.ON_COLOR} />
            サイト管理画面へ
          </ItemAlign>
        </Button>
      </TableRowItem>
      <TableRowItem width={160}>
        <Text size={14}>{site.domain}</Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <Text size={14}>{site.project_number}</Text>
      </TableRowItem>
      <TableRowItem width={88} innerCenter>
        <Badge badgeType={site.is_test ? BadgeType.SUCCESS : BadgeType.CRITICAL}>
          {site.is_test ? 'テスト環境' : '本番環境'}
        </Badge>
      </TableRowItem>
      <TableRowItem width={64} innerCenter>
        <Badge badgeType={site.is_active ? BadgeType.SUCCESS : BadgeType.SECONDARY}>
          {site.is_active ? '稼働中' : '非稼働'}
        </Badge>
      </TableRowItem>
      <TableRowItem width={88} innerCenter>
        {/* 全サイトが W2Commerce 完全連動。連動していることは一覧でも示す */}
        <Badge badgeType={BadgeType.SQUARE_BRAND}>W2</Badge>
      </TableRowItem>
      <TableRowItem width={200}>
        <ItemAlign gapX={4} gapY={4}>
          {site.enable_reco_media && <Badge badgeType={BadgeType.SUCCESS}>Reco-Media</Badge>}
          {site.enable_mail_reco && (
            <Badge badgeType={BadgeType.SUCCESS}>メールレコメンド</Badge>
          )}
          {site.enable_content_analysis && (
            <Badge badgeType={BadgeType.SUCCESS}>Media-DRIVER</Badge>
          )}
          {site.enable_article_upload && (
            <Badge badgeType={BadgeType.SUCCESS}>記事アップロード</Badge>
          )}
          {site.enable_geo_llmo && <Badge badgeType={BadgeType.SUCCESS}>AI検索最適化</Badge>}
          {site.enable_review && <Badge badgeType={BadgeType.SUCCESS}>UGC Intelligence</Badge>}
          {site.enable_ai_purchase_assist && <Badge badgeType={BadgeType.SUCCESS}>Findee</Badge>}
          {site.enable_search_suggest && (
            <Badge badgeType={BadgeType.SUCCESS}>検索サジェスト</Badge>
          )}
          {site.enable_carte && <Badge badgeType={BadgeType.SUCCESS}>カルテ</Badge>}
          {site.enable_full_behavior && (
            <Badge badgeType={BadgeType.SUCCESS}>カルテ：行動履歴取得</Badge>
          )}
        </ItemAlign>
      </TableRowItem>
    </ClickableTableRow>
  )
}

export default SiteListRow
